import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { tiptapJsonToSegments } from '../../../../lib/rteTableHelper';

const HEADING_FONT_SIZES = { 1: 32, 2: 24, 3: 18.72, 4: 16, 5: 13.28, 6: 10.72 };

const StyledStaticContent = styled.div`
  min-height: 24px;
  padding: 2px 4px;
  font-size: 12px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: text;
  word-break: break-word;
`;

function TiptapStaticRenderer({ content, onClick, className }) {

  const segments = useMemo(() => tiptapJsonToSegments(content), [content]);

  return (
    <StyledStaticContent onClick={onClick} className={className}>
      {segments.length === 0 && <span>&nbsp;</span>}
      {segments.map((segment, i) => {
        if (segment.isBreak) {
          return <br key={i} />;
        }
        const style = {};
        if (segment.bold || segment.headingLevel) style.fontWeight = 'bold';
        if (segment.italic) style.fontStyle = 'italic';
        if (segment.underline && segment.strike) style.textDecoration = 'underline line-through';
        else if (segment.underline) style.textDecoration = 'underline';
        else if (segment.strike) style.textDecoration = 'line-through';
        if (segment.headingLevel) style.fontSize = `${HEADING_FONT_SIZES[segment.headingLevel] || 16}px`;
        if (segment.textStyleColor) style.color = segment.textStyleColor;
        return (
          <span key={i} style={Object.keys(style).length > 0 ? style : undefined}>
            {segment.text}
          </span>
        );
      })}
    </StyledStaticContent>
  );

}

TiptapStaticRenderer.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default memo(TiptapStaticRenderer);
